import React from "react";
import "../styles.css";
import { Link} from "react-router-dom";

const ImageContainer = ({ value }) => {
  return (
    <>
      {value.map((val) => (
        <Link key={val.id.videoId}  to={{pathname:`/${val.id.videoId}` ,state:{info:val} } } >
          <img
            id="pop_img"
            src={val.snippet.thumbnails.high.url}
            alt=""
          />
        </Link>
      ))}
    </>
  );
};

export default ImageContainer;
